module.exports = new __parcel__URL__("error-modal.9d4de729.svg").toString();